import { axios } from "@Root/API";

export const getFinanceTuitionFeesStudent = params => {
  return axios.get("find/student", { params });
};
